import React from 'react';
import { withRouteData } from 'react-static';
import {
  TwoColScrollLayout,
  TwoColStickyLayout,
  TwoColContentLayout,
  ContentWrapper,
  FlowStripeWrapper,
  PageTitle
} from '@flow/components/ui';
import { IPage } from 'types/IPage';
import FlowStripe from '@flow/components/ticker/FlowStripe';
import * as NavigationAction from '@flow/store/navigation/actions';
import { connect } from 'react-redux';
import SEOTags from '@flow/components/seo/SEOTags';
import { renderContent, renderImageCarousel } from '@flow/scenes/default/ui';
import PageSubnavigation from '@flow/scenes/default/ui/PageSubnavigation';
import { TextAnimation } from '@flow/components/animation/TextAnimation';

interface Props {
  appLanguage: IAppLanguage;
  page: IPage;
  _setLanguage: any;
}

interface State {
  canTitleAnimate: boolean;
}

class DefaultPage extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      canTitleAnimate: false
    };
  }

  componentWillMount() {
    const {
      appLanguage,
      _setLanguage,
      page: {
        lang_versions
      }
    } = this.props;

    _setLanguage({ appLanguage, lang_versions });
  }

  componentWillReceiveProps({
    appLanguage,
    page: {
      lang_versions,
    }
  }: Props) {
    const {
      _setLanguage,
    } = this.props;

    _setLanguage({ appLanguage, lang_versions });
  }

  componentDidMount() {
    this.setState({canTitleAnimate: true});
  }

  render() {
    const {
      page: {
        title,
        images,
        content_group,
        side_navigation
      }
    } = this.props;

    const { page } = this.props;
    const { canTitleAnimate } = this.state;

    return (
      <TwoColScrollLayout>
        <SEOTags page={page} />
        <TwoColStickyLayout>
          { renderImageCarousel(images) }
        </TwoColStickyLayout>
        <TwoColContentLayout>
          <FlowStripeWrapper>
            <FlowStripe animate={true} rotation={90} color={'#000000'} />
          </FlowStripeWrapper>
          <ContentWrapper>
            <PageSubnavigation navigation={side_navigation}/>
            {title &&
            <PageTitle>
              <TextAnimation text={title} animateIn={canTitleAnimate} />
            </PageTitle>
            }
            { renderContent(content_group) }
          </ContentWrapper>
        </TwoColContentLayout>
      </TwoColScrollLayout>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    _setLanguage: ({appLanguage, lang_versions }: ISetLanguage) => {
      dispatch(NavigationAction.setLanguage(appLanguage, lang_versions));
    }
  }
};

export default connect(
  null,
  mapDispatchToProps
)(withRouteData(DefaultPage));



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/default/DefaultPage.tsx